{
  "account_updated": "Profile updated successfully",
  "reset_requested": "Password reset requested",
  "form": {
    "errors": {
      "password_mismatch": "Password's don't match",
      "password_minimum": "Password must be at least 6 characters long"
    },
    "account": {
      "tab": "Account",
      "title": "Update Account Details",
      "email": "Email",
      "first_name": "First Name",
      "last_name": "Last Name"
    },
    "password": {
      "tab": "Password",
      "title": "Reset Password",
      "current_password": "Current Password",
      "new_password": "New Password",
      "new_password_confirmation": "Confirm New Password"
    },
    "forgot_password": {
      "title": "Forgot Password",
      "email": "Email",
      "action": "Reset Password"
    },
    "reset_password": {
      "title": "Reset Password",
      "action": "Reset Password"
    },
    "sign_in": {
      "email": "Email",
      "password": "Password",
      "action": "Log In",
      "forgot_password": "Forgot Password?"
    }
  }
}
